import { roles } from "./../../../configs/constants";

export const formatExpenseTypes = (rawExpenseTypes = []) => {
  const formatedExpense = rawExpenseTypes.reduce((acc, cur) => {
    if (cur.type in acc) {
      acc[cur.type].push(cur);
    } else {
      acc[cur.type] = [cur];
    }
    return acc;
  }, {});
  return formatedExpense;
};

export const getExpenseTypes = (expenseTypes, userRoleId) => {
  let expensesTypesTab = Object.keys(expenseTypes).map(type => ({ label: type, id: type }));

  return userRoleId > 3 ? expensesTypesTab.filter(item => item.label !== "Repas") : expensesTypesTab;
};

export const getSubtypesOfType = (expenseTypes, type, userRoleId) => {
  if (userRoleId === roles.TERRAIN) {
    return expenseTypes[type].filter(item => item.display_form_terrain);
  }
  return expenseTypes[type];
};

export const getExpenseTypeLabel = (expenseTypes, expenseTypeId) => {
  const expenseTypesObjs = getExpenseTypes(expenseTypes);
  const expenseType = expenseTypesObjs.find(expenseType => expenseType.id === expenseTypeId);
  if (expenseType) return expenseType.label;
  return null;
};

export const isExpenseSubTypetoBillToClient = (expenseSubtypes = [], expenseSubtypeId) => {
  if (!Array.isArray(expenseSubtypes)) return false;
  const subtypeObj = expenseSubtypes.find(exp => exp._id === expenseSubtypeId);

  if (subtypeObj) return subtypeObj.to_reinvoice;
  return subtypeObj;
};

export const isMealProcessed = (day = {}) => {
  const mealPackage = day.meal_packages || [];
  if (!Array.isArray(mealPackage) || !mealPackage[0]) return false;
  return mealPackage[0].processed === true;
};

export const isMealValidated = (day = {}) => {
  const mealPackage = day.meal_packages || [];
  if (!Array.isArray(mealPackage) || !mealPackage[0]) return false;
  return mealPackage[0].validated === true;
};

export const isExpenseSubTypeIsWithTva = (expenseSubtypes = [], expenseSubtypeId) => {
  if (!Array.isArray(expenseSubtypes)) return false;
  const subtypeObj = expenseSubtypes.find(exp => exp._id === expenseSubtypeId);

  if (!subtypeObj) return false;
  return subtypeObj.tva_rules !== "0";
};



// WEBPACK FOOTER //
// src/modules/presence/utils/expense.utils.js